import * as React from 'react';

const PlusAlt = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#3A4BA9"
      fillRule="evenodd"
      d="M14,10 L22,10 C23.105,10 24,10.895 24,12 C24,13.105 23.105,14 22,14 L14,14 L14,22 C14,23.105 13.105,24 12,24 C10.895,24 10,23.105 10,22 L10,14 L2,14 C0.895,14 0,13.105 0,12 C0,10.895 0.895,10 2,10 L10,10 L10,2 C10,0.895 10.895,0 12,0 C13.105,0 14,0.895 14,2 L14,10 Z"
    />
  </svg>
);

export default PlusAlt;



// WEBPACK FOOTER //
// ./src/assets/images/icons/plus-alt.js